import script from "./empower.vue?vue&type=script&setup=true&lang=js"
export * from "./empower.vue?vue&type=script&setup=true&lang=js"

import "./empower.vue?vue&type=style&index=0&id=7b9872ed&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9872ed"]])

export default __exports__